import { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { Frame } from "../components/spec/Frame";
import { Overline } from "../components/ui-regera/Section";
import { useServices } from "../lib/hooks";
import { groupServices } from "../data/catalog";
import { requestRepack } from "../frames";

export default function Services() {
  const services = useServices();
  const groups = useMemo(() => groupServices(services), [services]);
  useEffect(() => {
    document.title = "Services — REGERA";
  }, []);
  // Content comes from the CMS: re-measure the frames whenever it changes.
  useEffect(() => {
    requestRepack();
  }, [groups]);
  return (
    <div data-testid="services-page">
      {groups.map((g, gi) => (
        <Frame key={g.key} id={`services-${g.key}`} first={gi === 0}>
          <Overline>Services · {gi + 1} of {groups.length}</Overline>
          {gi === 0 ? (
            <h1 data-pg-label className="mt-5 font-display font-black text-white tracking-tight text-3xl sm:text-4xl xl:text-5xl">{g.title}</h1>
          ) : (
            <h2 data-pg-label className="mt-5 font-display font-black text-white tracking-tight text-3xl sm:text-4xl xl:text-5xl">{g.title}</h2>
          )}
          <div className="mt-8 grid lg:grid-cols-3 gap-6">
            {g.items.map((s) => (
              <article key={s.slug || s.id} id={s.slug} data-pg-item data-testid={`service-${s.slug}`} className="border border-white/10 bg-[#111] p-6 lg:p-7 flex flex-col scroll-mt-28">
                <span className="font-display text-sm font-bold text-[#e60000]">{s.n}</span>
                <h3 className="mt-3 font-display text-xl xl:text-2xl font-bold text-white leading-tight">{s.title}</h3>
                <p className="mt-3 text-white/75 leading-relaxed">{s.text}</p>
                <ul className="mt-5 space-y-2.5 flex-1">
                  {(s.points || []).map((pt) => (
                    <li key={pt} className="flex gap-3 text-sm text-white/85">
                      <Check className="h-4 w-4 text-[#e60000] shrink-0 mt-0.5" />
                      {pt}
                    </li>
                  ))}
                </ul>
                <Link
                  to={`/contact?area=${encodeURIComponent(s.area || s.title)}#enquiry`}
                  data-testid={`enquire-${s.slug}`}
                  className="mt-6 inline-flex items-center gap-2 text-xs tracking-[0.16em] uppercase text-white hover:text-[#e60000] transition-colors"
                >
                  Enquire About This Service <ArrowUpRight className="h-4 w-4" />
                </Link>
              </article>
            ))}
          </div>
        </Frame>
      ))}
    </div>
  );
}
